//https://doc.myoas.com/pages/viewpage.action?pageId=85598895 0=文字，1=图文, 2=短视频, 3=图集 ，4=小视频,

export const contentTypeMap = {
    0: '文字',
    1: '图文',
    2: '短视频',
    3: '图集',
    4: '小视频',
};

export const OS_VERSIONS = {
  OS_15: '15',
  OS_16: '16',
};